import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { AppConfigService } from './app-config.service'
import { UrlCollection } from '@dot-it/jml-lib'
import { Observable } from 'rxjs'

class URLGroup {
  constructor(protected appConfigService: AppConfigService) {}

  protected simpleUrl(controllerPath: string, api: string): Observable<string> {
    return this.appConfigService.getBaseUrl$().pipe(map((baseUrl) => `${baseUrl}/${controllerPath}/${api}`))
  }
}

class UserManagement extends URLGroup {
  private static PATH = 'user'

  public VALIDATE_TOKEN$(token: string): Observable<string> {
    return this.appConfigService
      .getBaseUrl$()
      .pipe(map((baseUrl) => `${baseUrl}/${UserManagement.PATH}/validateToken/${token}`))
  }
}

class Config extends URLGroup {
  private static PATH = 'config'

  public APP_LOGO$ = () => this.simpleUrl(Config.PATH, 'applogo')
  public CUSTOMER_LOGO$ = () => this.simpleUrl(Config.PATH, 'customerlogo')
  public WELCOME_TEXT$ = () => this.simpleUrl(Config.PATH, 'welcomeTxt')
}

/** This service gets urls as observables. This is useful for cases, where urls will be needed before the loading of the postbuild config is through.
 * This will avoid problems with initial loading of the jml site on a fresh browser (or a browser with cleared local storage)
 * Mainly this concerns all urls needed on the login-page. but with page-refresh it could concern more urls.
 */
@Injectable({
  providedIn: 'root'
})
export class UrlAsObservableService {
  public UserManagement: UserManagement
  public Config: Config

  constructor(private appConfigService: AppConfigService) {
    this.UserManagement = new UserManagement(this.appConfigService)
    this.Config = new Config(this.appConfigService)
  }
}
